import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

import { BreadcrumbItem } from './breadcrumb-item.interface';

@Component({
  selector: 'umkt-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {
  @Input() items: BreadcrumbItem[] = [];
  @Input() separator: string = '/';
  @Input() showIcons: boolean = true;
  @Input() maxItems: number = 5;
  @Input() useChevronIcon: boolean = false;

  @Output() itemClick = new EventEmitter<BreadcrumbItem>();

  onItemClick(item: BreadcrumbItem, index: number): void {
    if (!item.disabled && item.url) {
      this.itemClick.emit(item);
    }
  }

  getVisibleItems(): BreadcrumbItem[] {
    if (this.items.length <= this.maxItems) {
      return this.items;
    }

    // Se há muitos itens, mostra o primeiro, último e alguns do meio
    const first = this.items[0];
    const last = this.items[this.items.length - 1];
    const middle = this.items.slice(1, -1);

    if (middle.length <= 2) {
      return this.items;
    }

    // Mostra alguns itens do meio
    const middleStart = Math.floor(middle.length / 2) - 1;
    const middleEnd = middleStart + 2;
    const visibleMiddle = middle.slice(middleStart, middleEnd);

    return [first, ...visibleMiddle, last];
  }

  isEllipsisNeeded(): boolean {
    return this.items.length > this.maxItems;
  }
}
